var _rect, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDaideeInterestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 16,
    fill: "#E6F2F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 14L20.5 26",
    stroke: "url(#paint0_linear_4957_5538)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 11L27.5 15",
    stroke: "url(#paint1_linear_4957_5538)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 13H29.5",
    stroke: "url(#paint2_linear_4957_5538)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 15.5H18C17.5 15.5 16.5 15.8 16.5 17V18.5C16.5 19 16.8 20 18 20H22.5C23 20 24 20.3 24 21.5V23C24 23.5 23.7 24.5 22.5 24.5H17",
    stroke: "url(#paint3_linear_4957_5538)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 10.8321C23.2751 10.2969 21.9222 10 20.5 10C14.9772 10 10.5 14.4772 10.5 20C10.5 25.5228 14.9772 30 20.5 30C26.0228 30 30.5 25.5228 30.5 20C30.5 18.7687 30.2775 17.5893 29.8704 16.5",
    stroke: "url(#paint4_linear_4957_5538)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4957_5538",
    x1: 20.5,
    y1: 19.9993,
    x2: 21.5,
    y2: 19.9993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59A9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0673A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4957_5538",
    x1: 27.5,
    y1: 12.9998,
    x2: 28.5,
    y2: 12.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59A9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0673A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4957_5538",
    x1: 25.5,
    y1: 13.4999,
    x2: 29.5,
    y2: 13.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59A9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0673A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4957_5538",
    x1: 16.5,
    y1: 19.9995,
    x2: 24,
    y2: 19.9995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59A9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0673A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4957_5538",
    x1: 10.5,
    y1: 19.9989,
    x2: 30.5,
    y2: 19.9989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59A9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0673A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaideeInterestIcon);
export default __webpack_public_path__ + "static/media/daidee-interest-icon.d2ec6f36ab06c487b96d802d14440e87.svg";
export { ForwardRef as ReactComponent };